export const environment = {
  production: true,
  buildId: '2580325464717801',
  configFile: 'config.json',
};
